import { createContext, useContext } from "react";

const AuthContext = createContext()
export default AuthContext;
const AuthContextSession = () => useContext(AuthContext);
export {AuthContextSession}